/* La Encantada — interactive enhancements (v4) */
(function () {
  // Add body class on La Encantada About page (any locale)
  if (/^\/(?:(?:ca|en)\/)?pages\/la-encantada(?:[\/?#]|$)/.test(location.pathname)) {
    document.documentElement.classList.add('lae-page-encantada');
    if (document.body) document.body.classList.add('lae-page-encantada');
    else document.addEventListener('DOMContentLoaded', function(){ document.body.classList.add('lae-page-encantada'); });
  }
  function init() {
    // Read-more on short description
    document.querySelectorAll('[data-block-id*="text_aEtTtq"]').forEach(function (el) {
      var p = el.querySelector('p');
      if (!p || !(p.textContent || '').trim()) { el.style.display = 'none'; return; }
      el.addEventListener('click', function (e) {
        var rect = el.getBoundingClientRect();
        var clickedNearBottom = (e.clientY - rect.top) > rect.height - 32;
        if (clickedNearBottom || el.classList.contains('expanded')) {
          el.classList.toggle('expanded');
        }
      });
    });
    document.querySelectorAll('[data-block-id*="subtitle_la"]').forEach(function (el) {
      var p = el.querySelector('p');
      if (!p || !(p.textContent || '').trim()) el.style.display = 'none';
    });
    document.querySelectorAll('[data-block-id*="volumen_text"]').forEach(function (el) {
      var p = el.querySelector('p');
      if (!p || !(p.textContent || '').replace(/·\s*IVA\s+incluido/i, '').trim()) el.style.display = 'none';
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ============================================================
   Accordion groups inside product_acc_la section
   ============================================================ */
(function () {
  function initAccordions() {
    // Target the section by id, find the 3 accordion groups inside
    var section = document.querySelector('[id*="product_acc_la"]');
    if (!section) return;

    // Each accordion is a group block with data-block-id*="acc_"
    var accordions = section.querySelectorAll('[data-block-id*="acc_"]');
    accordions.forEach(function (group) {
      if (group.dataset.laeAccInit === '1') return;
      group.dataset.laeAccInit = '1';
      group.classList.add('lae-acc');

      // Find direct text-block children (title and body)
      // They may be wrapped in extra divs by Horizon — look for any descendant text blocks
      var textBlocks = group.querySelectorAll('[data-block-type="text"]');
      if (textBlocks.length < 2) return;

      var titleBlock = textBlocks[0];
      var bodyBlock = textBlocks[1];

      // Add classes
      titleBlock.classList.add('lae-acc__title');
      bodyBlock.classList.add('lae-acc__body');

      // Hide body
      bodyBlock.style.display = 'none';

      // Click handler on title (or any clickable area in the title block)
      titleBlock.style.cursor = 'pointer';
      titleBlock.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = group.classList.toggle('lae-acc--open');
        bodyBlock.style.display = isOpen ? '' : 'none';
      });

      // Hide entirely if body empty
      var txt = (bodyBlock.textContent || '').replace(/\s+/g, ' ').trim();
      if (!txt) group.style.display = 'none';
    });
  }
  if (document.readyState !== 'loading') initAccordions();
  else document.addEventListener('DOMContentLoaded', initAccordions);
  document.addEventListener('shopify:section:load', initAccordions);
})();

/* ============================================================
   Bundle: 3 productos -10%
   ============================================================ */
(function () {
  function fmt(amount) { return (amount / 100).toFixed(2).replace('.', ',') + ' €'; }
  function init() {
    document.querySelectorAll('.lae-bundle').forEach(function (bundle) {
      var pct = parseFloat(bundle.dataset.bundleDiscount || '0') / 100;
      var items = bundle.querySelectorAll('.lae-bundle__item input[type="checkbox"]');
      var totalEl = bundle.querySelector('.lae-bundle__total-final');
      var origEl  = bundle.querySelector('.lae-bundle__total-original');
      var countEl = bundle.querySelector('.lae-bundle__sel-count');
      var cta = bundle.querySelector('[data-add-bundle]');
      function update() {
        var sel = Array.from(items).filter(function (i) { return i.checked; });
        var subtotal = sel.reduce(function (s, i) { return s + parseInt(i.dataset.price, 10); }, 0);
        var discounted = (sel.length >= 3) ? subtotal * (1 - pct) : subtotal;
        countEl.textContent = sel.length;
        totalEl.textContent = fmt(discounted);
        if (sel.length >= 3) { origEl.textContent = fmt(subtotal); origEl.hidden = false; }
        else origEl.hidden = true;
        cta.disabled = sel.length < 1;
        cta.textContent = sel.length >= 3 ? 'Añadir 3 al carrito (-10%)'
                       : sel.length === 1 ? 'Añadir 1 al carrito'
                       : 'Añadir ' + sel.length + ' al carrito';
      }
      items.forEach(function (i) { i.addEventListener('change', update); });
      update();
      cta.addEventListener('click', function () {
        var sel = Array.from(items).filter(function (i) { return i.checked; });
        if (!sel.length) return;
        cta.disabled = true; cta.textContent = 'Añadiendo…';
        fetch('/cart/add.js', {
          method: 'POST', headers: {'Content-Type':'application/json'},
          body: JSON.stringify({ items: sel.map(function (i) { return { id: parseInt(i.dataset.bundleId, 10), quantity: 1 }; }) })
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { cta.disabled = false; cta.textContent = 'Reintentar'; });
      });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* ============================================================
   Cart upsell — add buttons + dynamic shipping bar
   ============================================================ */
(function () {
  function fmtEUR(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateShippingBar() {
    var bar = document.querySelector('.lae-ship');
    if (!bar) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var threshold = parseInt(bar.dataset.threshold, 10);
        var current = cart.total_price;
        bar.dataset.current = current;
        var pct = Math.min(100, Math.round(current / threshold * 100));
        var fill = bar.querySelector('.lae-ship__fill');
        if (fill) fill.style.width = pct + '%';
        var track = bar.querySelector('.lae-ship__bar');
        if (track) {
          track.setAttribute('aria-valuenow', pct);
          track.setAttribute('aria-valuetext', pct + '%');
        }
        bar.classList.toggle('lae-ship--reached', current >= threshold);
        var msg = bar.querySelector('.lae-ship__msg');
        if (msg) {
          if (current >= threshold) {
            msg.innerHTML = '🎉 <strong>¡Felicidades! Tu envío es gratis.</strong>';
          } else {
            var remaining = threshold - current;
            msg.innerHTML = '🚚 Te faltan <strong>' + fmtEUR(remaining) + '</strong> para conseguir <strong>envío gratis</strong>';
          }
        }
      })
      .catch(function () {});
  }

  function init() {
    // + Añadir buttons in cart bundle
    document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = parseInt(btn.dataset.addToCart, 10);
        if (!id) return;
        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = 'Añadiendo…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        }).then(function (r) { return r.json(); })
          .then(function () {
            btn.textContent = '✓ Añadido';
            setTimeout(function () { window.location.reload(); }, 600);
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = originalText;
          });
      });
    });

    // Listen for cart changes
    document.addEventListener('cart:updated', updateShippingBar);
    document.addEventListener('cart:refresh', updateShippingBar);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* ============================================================
   Move shipping bar to top of cart page
   ============================================================ */
(function () {
  function reposition() {
    var ship = document.querySelector('.lae-ship');
    var title = document.querySelector('.cart-page__title');
    var items = document.querySelector('.cart-page__items');
    if (ship && title && title.parentNode) {
      title.parentNode.insertBefore(ship, title.nextSibling);
    } else if (ship && items && items.parentNode) {
      items.parentNode.insertBefore(ship, items);
    }
  }
  if (document.readyState !== 'loading') reposition();
  else document.addEventListener('DOMContentLoaded', reposition);
})();





/* ============================================================
   Cart drawer — inject shipping bar at top (FIXED)
   ============================================================ */
(function () {
  var THRESHOLD = 4500;
  function fmt(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function build(total) {
    var pct = Math.min(100, Math.round(total / THRESHOLD * 100));
    var msg;
    if (total >= THRESHOLD) {
      msg = '🎉 <strong>¡Felicidades! Tu envío es gratis.</strong>';
    } else {
      msg = '🚚 Te faltan <strong>' + fmt(THRESHOLD - total) + '</strong> para envío gratis';
    }
    var alcanzado = total >= THRESHOLD;
    return '<div class="lae-ship lae-ship--drawer' + (alcanzado ? ' lae-ship--reached' : '') + '">' +
           '<div class="lae-ship__msg">' + msg + '</div>' +
           '<div class="lae-ship__bar" role="progressbar" aria-valuemin="0" aria-valuemax="100"' +
           ' aria-valuenow="' + pct + '" aria-valuetext="' + pct + '%">' +
           '<div class="lae-ship__fill" style="width:' + pct + '%"></div></div>' +
           '</div>';
  }

  function inject() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    var items = drawer.querySelector('.cart-drawer__items, .cart-items__wrapper');
    if (!items) return;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      var existing = drawer.querySelector('.lae-ship--drawer');
      if (existing) existing.remove();
      items.insertAdjacentHTML('beforebegin', build(cart.total_price));
    }).catch(function(){});
  }

  // Inject on drawer open via click on cart trigger
  document.addEventListener('click', function(e) {
    // La tienda esta en espanol: el boton es aria-label="Carrito", asi que el
    // selector en ingles no casaba NUNCA y esta via de inyeccion estaba muerta
    // (solo funcionaba por el MutationObserver de mas abajo). Cubrimos ambos
    // idiomas y la clase del tema, que no depende del idioma.
    var trg = e.target.closest('[aria-label="Cart"], [aria-label="Carrito"], [aria-label="Cistella"], .header-actions__action, [data-testid="cart-drawer-trigger"]');
    if (trg) setTimeout(inject, 250);
  });

  // After any cart update event
  // 'cart:update' es el evento REAL de Horizon (assets/events.js). Los otros son
  // legacy y no los emite nadie: por eso este modulo solo reaccionaba de rebote.
  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:change', 'cart:rendered'].forEach(function(evt) {
    document.addEventListener(evt, function() { setTimeout(inject, 150); });
  });

  // Watch for drawer state changes
  var observer = new MutationObserver(function() {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && drawer.querySelector('.cart-drawer__items') && !drawer.querySelector('.lae-ship--drawer')) {
      inject();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'aria-hidden'] });

  // Initial inject on page load (in case drawer is already populated)
  if (document.readyState !== 'loading') setTimeout(inject, 500);
  else document.addEventListener('DOMContentLoaded', function() { setTimeout(inject, 500); });
})();





/* ============================================================
   Cart drawer bundle — DEBOUNCED, single injection
   ============================================================ */
(function () {
  var injectTimer = null;
  var isInjecting = false;

  function eur(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }

  function fetchSuggestions(excludeIds) {
    return fetch('/recommendations/products.json?product_id=' + (excludeIds[0] || 1) + '&limit=6&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var prods = (d.products || []).filter(function (p) {
          return excludeIds.indexOf(p.id) === -1 && p.available;
        });
        return prods.sort(function (a, b) { return a.price - b.price; }).slice(0, 2);
      })
      .catch(function () {
        return fetch('/products.json?limit=20')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            return (d.products || []).filter(function (p) {
              return excludeIds.indexOf(p.id) === -1 && p.available && p.variants && p.variants[0];
            }).sort(function (a, b) {
              return (parseInt(a.variants[0].price, 10) || 0) - (parseInt(b.variants[0].price, 10) || 0);
            }).slice(0, 2);
          });
      });
  }

  function buildBundle(prods) {
    if (!prods.length) return '';
    var cards = prods.map(function (p) {
      var v = p.variants && p.variants[0]; if (!v) return '';
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var imgUrl = typeof img === 'string' ? img : (img.src || '');
      var price = typeof v.price === 'number' ? v.price : parseInt(String(v.price).replace(/[^\d]/g, ''), 10);
      return '<div class="lae-drawer-bundle__card">' +
        '<a href="' + (p.url || '/products/' + p.handle) + '" class="lae-drawer-bundle__img">' +
        (imgUrl ? '<img src="' + imgUrl + '" alt="' + (p.title || '') + '" width="48" height="48">' : '') +
        '</a>' +
        '<div class="lae-drawer-bundle__info">' +
          '<a href="' + (p.url || '/products/' + p.handle) + '" class="lae-drawer-bundle__name">' + (p.title || '').substring(0, 32) + '</a>' +
          '<span class="lae-drawer-bundle__price">' + eur(price) + '</span>' +
        '</div>' +
        '<button class="lae-drawer-bundle__add" data-add-variant="' + v.id + '" aria-label="' + ((window.LAE_I18N && window.LAE_I18N.add_short) || 'Añadir') + '"></button>' +
      '</div>';
    }).join('');
    return '<div class="lae-drawer-bundle lae-drawer-bundle--collapsible">' +
      '<button type="button" class="lae-drawer-bundle__title" data-lae-bundle-toggle aria-expanded="false">' +
        '✨ Completa tu pedido' +
        '<span class="lae-drawer-bundle__arrow" aria-hidden="true">›</span>' +
      '</button>' +
      '<div class="lae-drawer-bundle__body" hidden>' + cards + '</div>' +
    '</div>';
  }

  /* ----------------------------------------------------------------
     Anadir un producto del upsell SIN cerrar el carrito.

     Antes esto hacia `window.location.reload()`: el producto se anadia, si,
     pero la pagina se recargaba entera y el drawer aparecia cerrado. El
     usuario perdia el hilo de la compra justo en el momento de ampliar pedido.

     Horizon ya sabe repintar el carrito sin recargar: `cart-items-component`
     escucha `cart:update` y, si el evento trae el HTML de su seccion, hace
     `morphSection`, que conserva el <dialog> abierto. Asi que pedimos las
     secciones en el propio POST y disparamos ese evento. Ojo con dos detalles
     del tema: el evento es `cart:update` (los `cart:updated`/`cart:refresh`
     que escuchaba este fichero NO existen en Horizon), y el handler ignora el
     evento si `event.target` es el propio componente, por eso se dispara
     sobre `document`.
     ---------------------------------------------------------------- */
  /* El tema decide si el resumen del carrito va pegado abajo (`sticky`) o en
     flujo normal, segun ocupe mas o menos del 50% del panel: si es muy alto y
     se queda pegado, TAPA los productos, porque lleva fondo y z-index. Pero ese
     calculo (#updateStickyState en cart-drawer.js) solo corre al ABRIR el
     drawer, nunca despues. Asi que al anadir una linea el estado se queda viejo
     y puede esconder producto. Aqui repetimos su misma regla tras cada cambio. */
  function recalcularResumenPegado() {
    var dlg = document.querySelector('cart-drawer-component dialog');
    if (!dlg) return;
    var contenido = dlg.querySelector('.cart-drawer__content');
    var resumen = dlg.querySelector('.cart-drawer__summary');
    if (!contenido || !resumen) { dlg.setAttribute('cart-summary-sticky', 'false'); return; }
    var altoPanel = dlg.getBoundingClientRect().height;
    if (!altoPanel) return;
    var proporcion = resumen.getBoundingClientRect().height / altoPanel;
    dlg.setAttribute('cart-summary-sticky', proporcion > 0.5 ? 'false' : 'true');
  }

  function avisar(texto) {
    // Fuera del drawer: el morph se lleva por delante cualquier nodo de dentro.
    var region = document.getElementById('lae-cart-live');
    if (!region) {
      region = document.createElement('p');
      region.id = 'lae-cart-live';
      region.className = 'lae-visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    region.textContent = texto;
  }

  function anadirDesdeElDrawer(variantId, btn) {
    if (btn.dataset.laeOcupado === '1') return;   // evita dobles envios
    btn.dataset.laeOcupado = '1';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');

    var nombre = '';
    var card = btn.closest('.lae-drawer-bundle__card');
    var enlace = card && card.querySelector('.lae-drawer-bundle__name');
    if (enlace) nombre = enlace.textContent.trim();

    var soltar = function () {
      btn.dataset.laeOcupado = '0';
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
    };

    var comp = document.querySelector('cart-drawer-component cart-items-component')
            || document.querySelector('cart-items-component');
    var idSeccion = comp && comp.dataset ? comp.dataset.sectionId : null;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: idSeccion || '',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, datos: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          throw new Error(res.datos.description || res.datos.message || 'No se ha podido añadir');
        }
        return fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var htmlSeccion = res.datos.sections && idSeccion ? res.datos.sections[idSeccion] : null;

            /* Repintado quirurgico: cambiamos SOLO el interior del
               <cart-items-component> del drawer.

               Se probaron los tres caminos del tema y ninguno sirve aqui:
               - `morphSection(id, html)` (modo 'full', el que usa
                 #handleCartUpdate por defecto) y `renderSection` repintan la
                 seccion ENTERA del header, que es donde vive el <dialog>. Al
                 reemplazar ese nodo se pierde el top layer que da showModal():
                 el panel conserva el atributo `open` pero colapsa a 84px de
                 alto y parece que el carrito se ha vaciado.
               - `morphSection(..., {mode:'hydration'})` respeta el <dialog>,
                 pero solo toca nodos con `data-hydration-key` y las filas del
                 carrito no lo llevan: la linea nueva aparecia a veces si y a
                 veces no.
               Cambiando solo el interior, el <dialog> ni se entera y las filas
               vienen ya renderizadas por Shopify. */
            if (htmlSeccion && comp) {
              try {
                var doc = new DOMParser().parseFromString(htmlSeccion, 'text/html');
                var candidatos = doc.querySelectorAll('cart-items-component');
                var nuevo = null;
                for (var i = 0; i < candidatos.length; i++) {
                  if (candidatos[i].closest('dialog')) { nuevo = candidatos[i]; break; }
                }
                if (!nuevo) nuevo = candidatos[0];
                if (nuevo) comp.innerHTML = nuevo.innerHTML;
              } catch (e) { /* si falla, el evento de abajo al menos sincroniza contadores */ }
            }

            var detalle = {
              resource: cart,
              sourceId: idSeccion || 'lae-drawer-bundle',
              data: {
                source: 'lae-drawer-bundle',
                sections: res.datos.sections,
                variantId: String(variantId),
                itemCount: cart.item_count
              }
            };

            // El evento se dispara DESDE el componente, no desde document: su
            // propio #handleCartUpdate ignora el evento si `event.target ===
            // this`, y asi no se repinta a si mismo (que es justo lo que
            // colapsaba el panel). Burbujea igual, asi que el contador del
            // icono del carrito y los avisos del tema si se enteran.
            var emisor = comp || document;
            emisor.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detalle }));
            // Cerramos el desplegable de sugerencias tras anadir. Dos razones:
            // ya has hecho lo que venias a hacer y lo que quieres ver es tu
            // carrito; y desplegado es alto, asi que con 2 lineas empujaba la
            // ultima por debajo del resumen pegado y parecia que se perdia.
            window.__laeBundleOpen = false;
            recalcularResumenPegado();
            avisar(nombre ? nombre + ' añadido al carrito.' : 'Producto añadido al carrito.');
            btn.classList.add('is-added');
            // El morph repinta la seccion y se lleva este boton; si por lo que
            // sea sigue vivo, lo devolvemos a su estado normal.
            setTimeout(function () { btn.classList.remove('is-added'); soltar(); }, 1200);
          });
      })
      .catch(function (err) {
        avisar((err && err.message) || 'No se ha podido añadir el producto.');
        soltar();
      });
  }

  function doInject() {
    if (isInjecting) return;
    isInjecting = true;
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) { isInjecting = false; return; }

    // Remove ALL existing bundles (cleans duplicates from races)
    drawer.querySelectorAll('.lae-drawer-bundle').forEach(function (el) { el.remove(); });

    var items = drawer.querySelector('.cart-drawer__items, .cart-items__wrapper');
    if (!items) { isInjecting = false; return; }

    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items || cart.items.length === 0) {
        isInjecting = false; return;
      }
      var excludeIds = cart.items.map(function (i) { return i.product_id; });
      fetchSuggestions(excludeIds).then(function (prods) {
        // Re-clean (something else may have injected in between)
        drawer.querySelectorAll('.lae-drawer-bundle').forEach(function (el) { el.remove(); });
        var html = buildBundle(prods);
        if (html) {
          // El upsell va DETRAS de la lista de productos, NO dentro del resumen.
          //
          // Se probo a meterlo dentro de .cart-drawer__summary para que bajase
          // junto a los totales y el hueco no partiese el panel. Efecto
          // secundario grave: el resumen es `position: sticky; bottom: 0` con
          // fondo y z-index, o sea que el contenido pasa POR DETRAS. Al hacerlo
          // mas alto empezo a TAPAR la segunda linea del carrito, que solo
          // aparecia al hacer scroll. Un hueco feo es cosmetico; esconder un
          // producto del carrito no lo es.
          items.insertAdjacentHTML('afterend', html);
          if (window.__laeBundleOpen) {
            var _wrap = drawer.querySelector('.lae-drawer-bundle');
            var _body = _wrap && _wrap.querySelector('.lae-drawer-bundle__body');
            var _btn = _wrap && _wrap.querySelector('[data-lae-bundle-toggle]');
            if (_wrap && _body && _btn) {
              _wrap.classList.add('is-open');
              _body.hidden = false;
              _btn.setAttribute('aria-expanded','true');
            }
          }
          drawer.querySelectorAll('.lae-drawer-bundle [data-add-variant]').forEach(function (btn) {
            btn.addEventListener('click', function () {
              var id = parseInt(btn.dataset.addVariant, 10); if (!id) return;
              anadirDesdeElDrawer(id, btn);
            });
          });
        }
        recalcularResumenPegado();
        isInjecting = false;
      }).catch(function () { isInjecting = false; });
    }).catch(function () { isInjecting = false; });
  }

  function scheduleInject() {
    if (injectTimer) clearTimeout(injectTimer);
    injectTimer = setTimeout(doInject, 250);
  }

  // Listen to multiple triggers — all debounced through scheduleInject
  document.addEventListener('click', function (e) {
    if (e.target.closest('[aria-label="Cart"], [aria-label="Carrito"], [aria-label="Cistella"], .header-actions__action, [data-testid="cart-drawer-trigger"]')) scheduleInject();
  });
  // Igual que arriba: el que de verdad dispara Horizon es 'cart:update'.
  ['cart:update', 'cart:updated', 'cart:refresh', 'cart:rendered', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, scheduleInject);
  });
  var obs = new MutationObserver(function () {
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && drawer.querySelector('.cart-drawer__items')) {
      var existing = drawer.querySelectorAll('.lae-drawer-bundle');
      if (existing.length === 0) scheduleInject();
      else if (existing.length > 1) {
        // Remove duplicates immediately
        for (var i = 1; i < existing.length; i++) existing[i].remove();
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'aria-hidden'] });
  if (document.readyState !== 'loading') scheduleInject();
  else document.addEventListener('DOMContentLoaded', scheduleInject);
})();


/* ============================================================
   La Encantada page — anchor mapping (menu links → sections)
   ============================================================ */
(function () {
  // Map anchor name → section key suffix (Shopify renders sections as
  // <div id="shopify-section-template--XXX__<key>">). We'll match by suffix.
  var ANCHOR_MAP = {
    'mireia':            'quien_soy',
    'historia':          'historia_intro',
    'quienes-somos':     'familia',
    'cosmetica':         'cosmetica_nacio',
    'como-lo-hacemos':   'como_intro',
    'nuestra-comunidad': 'comunidad'
  };

  function findSection(key) {
    var sels = ['[id$="__' + key + '"]', '[id$="' + key + '"]'];
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (el) return el;
    }
    return null;
  }

  function scrollToAnchor(hash) {
    if (!hash) return;
    var name = hash.replace(/^#/, '');
    var sectionKey = ANCHOR_MAP[name];
    if (!sectionKey) return;
    var el = findSection(sectionKey);
    if (!el) return;
    var headerH = document.querySelector('header')?.offsetHeight || 80;
    var top = el.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  // On initial load
  if (location.hash) {
    setTimeout(function () { scrollToAnchor(location.hash); }, 250);
  }
  // On internal anchor click (hash change without reload)
  window.addEventListener('hashchange', function () {
    scrollToAnchor(location.hash);
  });
  // Intercept clicks on /pages/la-encantada#anchor links
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.indexOf('/pages/la-encantada#') !== 0) return;
    var hash = href.split('#')[1];
    // If we are already on la-encantada page, prevent default and scroll
    if (location.pathname === '/pages/la-encantada') {
      e.preventDefault();
      history.replaceState(null, '', '#' + hash);
      scrollToAnchor('#' + hash);
    }
  });
})();


/* ============================================================
   FAVORITOS — localStorage wishlist
   ============================================================ */
(function () {
  var KEY = 'lae_favoritos';

  function getList() {
    // Normaliza siempre a un array de strings: si el almacenamiento trae basura
    // (JSON corrupto, un objeto, nulos), mejor lista vacia que reventar el
    // render de toda la pagina.
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(v)) return [];
      return v.filter(function (x) { return typeof x === 'string' && x; });
    } catch (e) { return []; }
  }
  function saveList(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch(e){}
    updateBadge();
  }
  function isFav(handle) { return getList().indexOf(handle) !== -1; }
  function toggle(handle) {
    var arr = getList();
    var i = arr.indexOf(handle);
    if (i === -1) arr.push(handle);
    else arr.splice(i, 1);
    saveList(arr);
    return arr.indexOf(handle) !== -1;
  }

  function updateBadge() {
    var trigger = document.querySelector('[data-lae-fav-trigger]');
    if (trigger) trigger.classList.toggle('has-favs', getList().length > 0);
    var el = document.querySelector('[data-lae-fav-count]');
    if (el) { el.hidden = true; el.textContent = ''; }
  }

  // Crea el boton de corazon para un handle dado. Se usa tanto en las tarjetas
  // <product-card> del tema como en las del carrusel de la home, para que el
  // comportamiento y el marcado sean exactamente los mismos en los dos sitios.
  function crearCorazon(handle, extraClase) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lae-fav-btn' + (extraClase ? ' ' + extraClase : '') + (isFav(handle) ? ' is-fav' : '');
    btn.setAttribute('aria-label', ((window.LAE_I18N && window.LAE_I18N.fav_add) || 'Añadir a favoritos'));
    btn.setAttribute('aria-pressed', isFav(handle) ? 'true' : 'false');
    btn.dataset.handle = handle;
    btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M10 17s-6.5-4-6.5-9a3.5 3.5 0 0 1 6.5-1.84A3.5 3.5 0 0 1 16.5 8c0 5-6.5 9-6.5 9Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
    btn.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var ahora = toggle(handle);
      btn.classList.toggle('is-fav', ahora);
      btn.setAttribute('aria-pressed', ahora ? 'true' : 'false');
      btn.setAttribute('aria-label', ahora
        ? ((window.LAE_I18N && window.LAE_I18N.fav_remove) || 'Quitar de favoritos')
        : ((window.LAE_I18N && window.LAE_I18N.fav_add) || 'Añadir a favoritos'));
    });
    return btn;
  }

  // Tarjetas del carrusel de la home: el corazon va en el contenedor de
  // acciones que renderiza la seccion, junto al quick add del tema.
  function attachHeartsToCarousel() {
    document.querySelectorAll('[data-lae-card-actions]').forEach(function (acciones) {
      if (acciones.dataset.laeFavAttached) return;
      var handle = acciones.dataset.handle;
      if (!handle) return;
      acciones.querySelectorAll(':scope > .lae-fav-btn').forEach(function (x) { x.remove(); });
      acciones.insertBefore(crearCorazon(handle, 'lae-fav-btn--card'), acciones.firstChild);
      acciones.dataset.laeFavAttached = '1';
    });
  }

  function attachHeartButtons() {
    attachHeartsToCarousel();
    // On product cards: add heart icon overlay (top-right corner)
    // ONLY iterate the custom element product-card to avoid processing nested wrappers twice
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.dataset.laeFavAttached) return;
      // Also remove any pre-existing .lae-fav-btn inside (dedupe)
      card.querySelectorAll(':scope .lae-fav-btn').forEach(function(x){ x.remove(); });
      var link = card.querySelector('a[href^="/products/"]');
      if (!link) return;
      var handle = (link.getAttribute('href').match(/\/products\/([^?#]+)/) || [])[1];
      if (!handle) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lae-fav-btn' + (isFav(handle) ? ' is-fav' : '');
      btn.setAttribute('aria-label', ((window.LAE_I18N && window.LAE_I18N.fav_add) || 'Añadir a favoritos'));
      btn.dataset.handle = handle;
      btn.innerHTML = '<svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 17s-6.5-4-6.5-9a3.5 3.5 0 0 1 6.5-1.84A3.5 3.5 0 0 1 16.5 8c0 5-6.5 9-6.5 9Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var nowFav = toggle(handle);
        btn.classList.toggle('is-fav', nowFav);
      });
      card.style.position = 'relative';
      card.appendChild(btn);
      card.dataset.laeFavAttached = '1';
    });

    // On product page: add to main image gallery area
    var prodPage = document.querySelector('product-information, .product-information');
    if (prodPage && !prodPage.dataset.laeFavAttached) {
      var url = location.pathname;
      var m = url.match(/\/products\/([^?#]+)/);
      if (m) {
        var handle = m[1];
        var media = prodPage.querySelector('[class*="media"], media-gallery');
        if (media) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'lae-fav-btn lae-fav-btn--product' + (isFav(handle) ? ' is-fav' : '');
          btn.setAttribute('aria-label', ((window.LAE_I18N && window.LAE_I18N.fav_add) || 'Añadir a favoritos'));
          btn.dataset.handle = handle;
          btn.innerHTML = '<svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 17s-6.5-4-6.5-9a3.5 3.5 0 0 1 6.5-1.84A3.5 3.5 0 0 1 16.5 8c0 5-6.5 9-6.5 9Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
          btn.addEventListener('click', function () {
            var nowFav = toggle(handle);
            btn.classList.toggle('is-fav', nowFav);
          });
          if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
          media.appendChild(btn);
          prodPage.dataset.laeFavAttached = '1';
        }
      }
    }
  }

  function renderFavoritesPage() {
    var root = document.getElementById('lae-favoritos-root');
    if (!root) return;
    var arr = getList();

    if (!arr.length) {
      root.innerHTML = '<div class="lae-favoritos__empty">' +
        '<p>' + ((window.LAE_I18N && window.LAE_I18N.fav_empty) || 'Aún no tienes favoritos guardados.') + '</p>' +
        '<a href="/collections/productos" class="button">Explorar productos</a>' +
        '</div>';
      return;
    }

    root.innerHTML = '<div class="lae-favoritos__grid"></div>';
    var grid = root.querySelector('.lae-favoritos__grid');

    Promise.all(arr.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) {
          // 404/410: el producto ya no existe o dejo de publicarse -> fuera de
          // la lista. Cualquier otro fallo (5xx, red) NO lo borra: perder
          // favoritos por un error temporal es mucho peor que no pintarlos.
          if (r.ok) return r.json().then(function (j) { return { estado: 'ok', handle: h, producto: j }; });
          if (r.status === 404 || r.status === 410) return { estado: 'nohay', handle: h };
          return { estado: 'error', handle: h };
        })
        .catch(function () { return { estado: 'error', handle: h }; });
    })).then(function (resultados) {
      var caidos = resultados.filter(function (r) { return r.estado === 'nohay'; }).map(function (r) { return r.handle; });
      var fallidos = resultados.filter(function (r) { return r.estado === 'error'; }).length;

      if (caidos.length) {
        // Releer antes de guardar: entre el fetch y ahora el usuario ha podido
        // tocar la lista en otra pestana.
        var actual = getList().filter(function (h) { return caidos.indexOf(h) === -1; });
        saveList(actual);
      }

      resultados.forEach(function (r) {
        if (r.estado !== 'ok') return;
        var p = r.producto;
        var img = (p.featured_image || (p.images && p.images[0]) || '');

        var card = document.createElement('div');
        card.className = 'lae-fav-card';

        // El enlace y el boton de quitar son HERMANOS: un <button> dentro de un
        // <a> es HTML invalido y el clic pelea con la navegacion.
        var enlace = document.createElement('a');
        enlace.className = 'lae-fav-card__link';
        enlace.href = '/products/' + p.handle;
        enlace.innerHTML =
          '<span class="lae-fav-card__media">' +
            (img ? '<img src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '" width="600" height="600" loading="lazy">' : '') +
          '</span>' +
          '<span class="lae-fav-card__info">' +
            '<span class="lae-fav-card__title">' + (p.title || '') + '</span>' +
            '<span class="lae-fav-card__price">' + ((p.price || 0) / 100).toFixed(2).replace('.', ',') + ' €</span>' +
          '</span>';

        var quitar = document.createElement('button');
        quitar.type = 'button';
        quitar.className = 'lae-fav-card__remove';
        quitar.dataset.handle = p.handle;
        quitar.setAttribute('aria-label',
          ((window.LAE_I18N && window.LAE_I18N.fav_remove) || 'Quitar de favoritos') + ': ' + (p.title || ''));
        quitar.innerHTML = '<span aria-hidden="true">✕</span>';
        quitar.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          toggle(p.handle);
          renderFavoritesPage();
        });

        card.appendChild(enlace);
        card.appendChild(quitar);
        grid.appendChild(card);
      });

      if (!grid.children.length) {
        root.innerHTML = '<div class="lae-favoritos__empty"><p>' +
          ((window.LAE_I18N && window.LAE_I18N.fav_empty) || 'Aún no tienes favoritos guardados.') +
          '</p><a href="/collections/productos" class="button">Explorar productos</a></div>';
        return;
      }

      // Un fallo de red no puede presentarse como "no tienes favoritos".
      if (fallidos) {
        var aviso = document.createElement('p');
        aviso.className = 'lae-favoritos__aviso';
        aviso.setAttribute('role', 'status');
        aviso.textContent = 'No hemos podido cargar ' + fallidos +
          (fallidos === 1 ? ' producto. Sigue guardado; vuelve a intentarlo.' : ' productos. Siguen guardados; vuelve a intentarlo.');
        root.appendChild(aviso);
      }
    });
  }

  function init() {
    updateBadge();
    attachHeartButtons();
    if (document.getElementById('lae-favoritos-root')) renderFavoritesPage();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // `shopify:section:load` SOLO lo dispara el editor del tema, no el storefront.
  document.addEventListener('shopify:section:load', init);
  setTimeout(attachHeartButtons, 500);
  setTimeout(attachHeartButtons, 1500);

  /* EL CORAZON QUE DESAPARECIA.

     Hasta aqui el enganche corria al cargar la pagina y en dos setTimeout, y se
     acabo. Pero Horizon repinta secciones enteras continuamente: filtros de
     coleccion, paginacion, el morph del carrito, el quick add... Cada repintado
     REEMPLAZA los nodos <product-card>, y los nuevos venian sin corazon porque
     nadie volvia a engancharlos. De ahi el "a veces desaparece": dependia de si
     habias tocado algo que repintara.

     Un MutationObserver sobre el body lo resuelve: cada vez que aparecen
     tarjetas nuevas, se les engancha. El guardia `dataset.laeFavAttached` hace
     que repetirlo sea barato y no duplique botones. */
  var pendiente = null;
  function reengancharPronto() {
    if (pendiente) return;
    pendiente = setTimeout(function () {
      pendiente = null;
      attachHeartButtons();
    }, 120);
  }

  var vigilante = new MutationObserver(function (mutaciones) {
    for (var i = 0; i < mutaciones.length; i++) {
      var anadidos = mutaciones[i].addedNodes;
      for (var j = 0; j < anadidos.length; j++) {
        var n = anadidos[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && (n.matches('product-card, [data-lae-card-actions]'))) return reengancharPronto();
        if (n.querySelector && n.querySelector('product-card, [data-lae-card-actions]')) return reengancharPronto();
      }
    }
  });
  function vigilar() { vigilante.observe(document.body, { childList: true, subtree: true }); }
  if (document.body) vigilar();
  else document.addEventListener('DOMContentLoaded', vigilar);

  // Y tras los eventos de carrito del tema, que tambien repintan.
  ['cart:update', 'cart:updated', 'cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, reengancharPronto);
  });
})();


/* ============================================================
   Inject heart icon next to search/cart icons via JS
   ============================================================ */
(function () {
  function injectHeart() {
    // Avoid duplicates
    if (document.querySelector('[data-lae-fav-trigger]')) return;
    // Buscar el contenedor de acciones del header (lado derecho)
    // OJO: querySelector con una lista devuelve el primero en ORDEN DE
    // DOCUMENTO, no en el orden en que escribes los selectores. Con la lista de
    // antes ganaba `.header__column--right`, asi que el corazon acababa como
    // HERMANO de <header-actions> en vez de dentro. En movil esa columna tiene
    // `display: contents` y sus dos hijos caian en la misma celda de la rejilla:
    // el corazon y la bolsa se dibujaban uno ENCIMA del otro. Hay que preguntar
    // en orden de preferencia, uno a uno.
    var rightActions = document.querySelector('header-actions')
                    || document.querySelector('.header-actions')
                    || document.querySelector('.header__column--right')
                    || document.querySelector('.header__inline-links-list-right');
    var search = document.querySelector('search-button');
    if (!rightActions && !search) return;
    var heart = document.createElement('a');
    heart.href = '/pages/favoritos';
    heart.setAttribute('aria-label', ((window.LAE_I18N && window.LAE_I18N.fav_title) || 'Favoritos'));
    heart.setAttribute('data-lae-fav-trigger', '');
    heart.className = 'header-actions__action button-unstyled';
    heart.innerHTML = '<span class="svg-wrapper" aria-hidden="true"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 17s-6.5-4-6.5-9a3.5 3.5 0 0 1 6.5-1.84A3.5 3.5 0 0 1 16.5 8c0 5-6.5 9-6.5 9Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" fill="none"/></svg></span>';
    // Insertar en el lado derecho del header
    if (rightActions) {
      // El corazon tiene que ser HIJO DIRECTO del contenedor de acciones. Un
      // `closest()` desde <cart-icon> sube al boton del carrito, que esta
      // anidado dentro de <cart-drawer-component>: insertando ahi, el corazon
      // acababa DENTRO del componente del carrito y en escritorio se
      // superponia con la bolsa. Asi que desde el objetivo subimos hasta el
      // hijo directo del contenedor.
      var hijoDirecto = function (nodo) {
        while (nodo && nodo.parentNode && nodo.parentNode !== rightActions) nodo = nodo.parentNode;
        return (nodo && nodo.parentNode === rightActions) ? nodo : null;
      };
      var referencia = hijoDirecto(rightActions.querySelector('search-button'))
                    || hijoDirecto(rightActions.querySelector('cart-icon'));
      if (referencia) {
        rightActions.insertBefore(heart, referencia);
      } else {
        rightActions.insertBefore(heart, rightActions.firstChild);
      }
    } else {
      search.parentNode.insertBefore(heart, search.nextSibling);
    }
    // Update has-favs class based on localStorage
    try {
      var list = JSON.parse(localStorage.getItem('lae_favoritos') || '[]');
      if (list.length > 0) heart.classList.add('has-favs');
    } catch(e) {}
  }
  if (document.readyState !== 'loading') injectHeart();
  else document.addEventListener('DOMContentLoaded', injectHeart);
  setTimeout(injectHeart, 200);
  setTimeout(injectHeart, 800);
})();


/* Añadir clase template-* al body según la URL (Horizon no la añade por defecto) */
(function () {
  var path = window.location.pathname;
  var c = '';
  if (path.startsWith('/collections/') && !path.includes('/products/')) c = 'template-collection';
  else if (path.startsWith('/products/')) c = 'template-product';
  else if (path === '/' || path === '') c = 'template-index';
  else if (path.startsWith('/pages/')) c = 'template-page';
  else if (path.startsWith('/cart')) c = 'template-cart';
  if (c) document.body.classList.add(c);
})();


/* ============================================================
   PARALLAX — efecto suave al hacer scroll (hero + secciones)
   ============================================================ */
(function laeParallaxInit() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function selectTargets() {
    var nodes = [];
    // Hero slideshow image/video
    document.querySelectorAll('slideshow-component .slide__image-container > img, slideshow-component .slide__image-container > video, slideshow-component .slide__video').forEach(function(el){ nodes.push({el: el, speed: 0.3, scale: 1.1}); });
    // Secciones home con background-image inline
    var selectors = [
      '[id*="que_necesitas"] [style*="background-image"]',
      '[id*="creado"] [style*="background-image"]',
      '[id*="consciente"] [style*="background-image"]',
      '[id*="antes_despues"] [style*="background-image"]',
      '[id*="pack_mujer"] [style*="background-image"]',
      '[id*="jaboneras"] [style*="background-image"]',
      '[id*="testimonios"] [style*="background-image"]',
      '[id*="instagram"] [style*="background-image"]',
      '[id*="hero_about"] [style*="background-image"]'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function(el){ nodes.push({el: el, speed: 0.25, scale: 1.12}); });
    return nodes;
  }

  var targets = [];
  function refresh() { targets = selectTargets(); }
  refresh();

  function update() {
    var vh = window.innerHeight;
    for (var i = 0; i < targets.length; i++) {
      var t = targets[i];
      var r = t.el.getBoundingClientRect();
      // sólo si está en o cerca del viewport
      if (r.bottom < -200 || r.top > vh + 200) continue;
      // distancia del centro del elemento al centro del viewport
      var centerOffset = (r.top + r.height/2) - vh/2;
      var ty = -centerOffset * t.speed;
      t.el.style.willChange = 'transform';
      t.el.style.transform = 'translate3d(0,' + ty.toFixed(1) + 'px,0) scale(' + t.scale + ')';
    }
  }

  var rafId = null;
  function onScroll() {
    if (rafId) return;
    rafId = requestAnimationFrame(function(){ rafId = null; update(); });
  }

  window.addEventListener('scroll', onScroll, {passive: true});
  window.addEventListener('resize', function(){ refresh(); update(); }, {passive: true});

  if (document.readyState !== 'loading') { refresh(); update(); }
  else document.addEventListener('DOMContentLoaded', function(){ refresh(); update(); });

  // re-detect después de navegación AJAX
  document.addEventListener('shopify:section:load', function(){ refresh(); update(); });
})();


/* PEDIR MUESTRA: la lógica antigua (basada en un único producto muestra-gratis
   con 11 variantes) se ha eliminado. Ahora vive en snippets/lae-sample.liquid
   (modal en ficha) y snippets/lae-muestra-ui.liquid (colección + restricciones
   globales), que operan sobre 11 productos independientes con tag `muestra-gratis`. */


/* ============================================================
   ANNOUNCEMENT MARQUEE — duplicar slides para loop sin corte
   ============================================================ */
(function () {
  function initMarquee() {
    var slides = document.querySelector('.announcement-bar__slides');
    if (!slides || slides.dataset.laeMarquee) return;
    slides.dataset.laeMarquee = '1';
    // Clone slides several times so many copies scroll seguidas (con loop sin corte)
    var kids = Array.from(slides.children);
    var TOTAL_COPIES = 3; // 1 original + 4 copies (10 total con 2 msgs)
    for (var i = 0; i < TOTAL_COPIES; i++) {
      kids.forEach(function (c) {
        var clone = c.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        slides.appendChild(clone);
      });
    }
  }
  if (document.readyState !== 'loading') initMarquee();
  else document.addEventListener('DOMContentLoaded', initMarquee);
})();


/* ============================================================
   PRODUCT CARD SUBTITLE — insertar subtitle debajo del título
   ============================================================ */
(function () {
  var raw = document.getElementById('lae-subtitles');
  if (!raw) return;
  var subtitles = {};
  try { subtitles = JSON.parse(raw.textContent || '{}'); } catch(e) { try { subtitles = JSON.parse((raw.textContent||'{}').replace(/,\s*}/g,'}').replace(/,\s*]/g,']')); } catch(e2) { return; } }
  
  function inject() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.dataset.laeSubDone) return;
      card.dataset.laeSubDone = '1';
      // Get handle from link href
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      var m = link.getAttribute('href').match(/\/products\/([^?\/#]+)/);
      if (!m) return;
      var handle = decodeURIComponent(m[1]);
      var subtitle = subtitles[handle];
      if (!subtitle) return;
      // Truncate: first sentence, no emojis/bullets, max 80 chars
      subtitle = String(subtitle)
        .replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{2700}-\u{27BF}]/gu, '')  // remove emojis
        .replace(/[✔️✅🌱🛁💚🌿✨💖]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
      var firstPeriod = subtitle.search(/[.!?]\s/);
      if (firstPeriod > 0 && firstPeriod < 100) {
        subtitle = subtitle.slice(0, firstPeriod + 1);
      } else if (subtitle.length > 80) {
        subtitle = subtitle.slice(0, 80).replace(/\s\S*$/, '') + '…';
      }
      if (!subtitle) return;
      // Find ALL title elements and inject subtitle after each (Horizon renders multiple placements)
      var titles = card.querySelectorAll('.text-block[class*="product_title"], .text-block[class*="product-title"], [class*="product_title"], [class*="product-title"], .product-title, .product-card__title, [class*="card__title"]');
      if (!titles.length) return;
      titles.forEach(function(title){
        if (title.nextElementSibling && title.nextElementSibling.classList.contains('lae-card-subtitle')) return;
        var el = document.createElement('div');
        el.className = 'lae-card-subtitle';
        el.textContent = subtitle;
        title.parentNode.insertBefore(el, title.nextSibling);
      });
    });
  }
  
  if (document.readyState !== 'loading') inject();
  else document.addEventListener('DOMContentLoaded', inject);
  // Re-inject after AJAX (filters, load more)
  document.addEventListener('shopify:section:load', inject);
  var mo = new MutationObserver(function(){ inject(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();


/* ============================================================
   MEGA MENU ECOPACK — usar imagen fondo blanco (2ª media) en menú
   ============================================================ */
(function () {
  var raw = document.getElementById('lae-menu-images');
  if (!raw) return;
  var menuImgs = {};
  try { menuImgs = JSON.parse(raw.textContent || '{}'); } catch(e) { try { menuImgs = JSON.parse((raw.textContent||'{}').replace(/,\s*}/g,'}').replace(/,\s*]/g,']')); } catch(e2) { return; } }
  
  function swap() {
    // Find mega-menu items whose href is /products/ecopack-...
    document.querySelectorAll('[class*="mega-menu"] a[href*="/products/ecopack"], .mega-menu a[href*="/products/ecopack"]').forEach(function(a){
      if (a.dataset.laeMenuSwap) return;
      var m = a.getAttribute('href').match(/\/products\/([^?\/#]+)/);
      if (!m) return;
      var handle = decodeURIComponent(m[1]);
      var url = menuImgs[handle];
      if (!url) return;
      var img = a.querySelector('img');
      if (!img) return;
      // Swap src + srcset
      img.src = url;
      img.srcset = '';
      a.dataset.laeMenuSwap = '1';
    });
  }
  if (document.readyState !== 'loading') swap();
  else document.addEventListener('DOMContentLoaded', swap);
  var mo = new MutationObserver(function(){ swap(); });
  mo.observe(document.body, { childList: true, subtree: true });
})();


/* ============================================================
   BUTTON TRANSLATIONS — ATC + Buy It Now en español
   ============================================================ */
(function () {
  var MAP = {
    'ADD TO CART': 'AÑADIR AL CARRITO',
    'Add to cart': 'Añadir al carrito',
    'Add to Cart': 'Añadir al carrito',
    'BUY IT NOW': 'COMPRAR AHORA',
    'Buy it now': 'Comprar ahora',
    'Buy It Now': 'Comprar ahora',
    'Sold out': 'Agotado',
    'SOLD OUT': 'AGOTADO',
    'Unavailable': 'No disponible',
    'Choose options': 'Elegir opciones',
    'View options': 'Ver opciones'
  };
  function translate() {
    document.querySelectorAll('add-to-cart-component button, accelerated-checkout button, .shopify-payment-button__button, button[name="add"], sticky-add-to-cart button').forEach(function(btn){
      if (btn.dataset.laeTrans) return;
      var el = btn.querySelector('span') || btn;
      var txt = (el.textContent || '').trim();
      if (MAP[txt]) { el.textContent = MAP[txt]; btn.dataset.laeTrans = '1'; return; }
      Object.keys(MAP).forEach(function(en){
        if (txt.indexOf(en) >= 0) {
          el.textContent = txt.replace(en, MAP[en]);
          btn.dataset.laeTrans = '1';
        }
      });
    });
  }
  if (document.readyState !== 'loading') translate();
  else document.addEventListener('DOMContentLoaded', translate);
  new MutationObserver(translate).observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   PRICE FORMAT — mover el € al final (32,00 €)
   ============================================================ */
(function () {
  function reformat() {
    document.querySelectorAll('.price, .price *, [class*="price"], .money').forEach(function(el){
      if (el.children.length > 0) return;  // solo hojas de texto
      if (el.dataset.laePriceFixed) return;
      var t = el.textContent;
      // Buscar patrón "€NN,NN" o "€NN" y transformar a "NN,NN €"
      var m = t.match(/^\s*€\s*(\d[\d.,]*)\s*$/);
      if (m) {
        el.textContent = m[1] + ' €';
        el.dataset.laePriceFixed = '1';
      }
    });
  }
  if (document.readyState !== 'loading') reformat();
  else document.addEventListener('DOMContentLoaded', reformat);
  new MutationObserver(reformat).observe(document.body, { childList: true, subtree: true });
})();






/* ============================================================
   ACCORDION MOVE — mover el acordeón DENTRO de la columna de imagen
   ============================================================ */
(function () {
  function move() {
    if (window.innerWidth < 990) return;
    var media = document.querySelector('.product-information__media');
    var accWrap = document.querySelector('[id*="acc_combina"] .lae-acc-wrap');
    if (!media || !accWrap) return;
    if (accWrap.dataset.laeMoved) return;
    // Move accWrap as the LAST child of media (which is the image gallery container)
    media.appendChild(accWrap);
    accWrap.dataset.laeMoved = '1';
    // Hide the original acc_combina section since we moved its content
    var sec = document.querySelector('[id*="acc_combina"]');
    if (sec) sec.style.display = 'none';
  }
  if (document.readyState !== 'loading') { setTimeout(move, 200); }
  else document.addEventListener('DOMContentLoaded', function(){ setTimeout(move, 200); });
})();


/* ============================================================
   COMBINA CON — Añadir al carrito desde la card
   ============================================================ */
(function () {
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-lae-add-variant]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var id = parseInt(btn.dataset.laeAddVariant, 10);
    if (!id) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function(r){ return r.json(); })
    .then(function(){
      btn.textContent = '✓';
      btn.style.background = '#273222';
      btn.style.color = '#fff';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // Abrir cart drawer con selector específico (el buscador comparte header-actions__action)
      var trg = document.querySelector('button[aria-label="Carrito"], button[aria-label="Cart"], button[aria-label="Cistella"]');
      if (trg) setTimeout(function(){ trg.click(); }, 400);
      setTimeout(function(){
        btn.textContent = orig;
        btn.style.background = '';
        btn.style.color = '';
        btn.disabled = false;
      }, 2500);
    })
    .catch(function(){
      btn.textContent = orig;
      btn.disabled = false;
    });
  });
})();


/* ============================================================
   COMBINA CON — Añadir al carrito desde la card
   ============================================================ */
(function () {
  function openCart() {
    // 1) Try clicking the BUTTON cart trigger (not the account div)
    var btn = document.querySelector('button[aria-label="Cart"], button[aria-label="Carrito"]');
    if (btn) { btn.click(); return; }
    // 2) Try cart-icon component
    var ic = document.querySelector('cart-icon');
    if (ic) { ic.click(); return; }
    // 3) Dispatch Horizon events
    document.dispatchEvent(new CustomEvent('cart:open', {bubbles: true}));
    document.dispatchEvent(new CustomEvent('dialog:open', {bubbles: true, detail: {id: 'cart-drawer'}}));
  }
  
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-lae-add-variant]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    var id = parseInt(btn.dataset.laeAddVariant, 10);
    if (!id) return;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: id, quantity: 1 })
    })
    .then(function(r){ if (!r.ok) throw new Error('add failed'); return r.json(); })
    .then(function(){
      btn.textContent = '✓';
      btn.style.background = '#273222';
      btn.style.color = '#fff';
      // Refresh cart data & UI
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
      // Open cart drawer
      setTimeout(openCart, 200);
      setTimeout(function(){
        btn.textContent = orig;
        btn.style.background = '';
        btn.style.color = '';
        btn.disabled = false;
      }, 2500);
    })
    .catch(function(err){
      console.error('Combina add error', err);
      btn.textContent = '✗';
      setTimeout(function(){ btn.textContent = orig; btn.disabled = false; }, 1500);
    });
  });
})();






/* ============================================================
   ATC ADDED FEEDBACK — cambio de texto INSTANTÁNEO
   ============================================================ */
(function () {
  document.addEventListener('click', function(e){
    var btn = e.target.closest('add-to-cart-component button, button[name="add"]');
    if (!btn) return;
    var span = btn.querySelector('span:not(.svg-wrapper):not(.visually-hidden)') || btn;
    var originalText = span.textContent.trim();
    if (originalText && !btn.dataset.laeOriginalText) {
      btn.dataset.laeOriginalText = originalText;
    }
    // Cambio INMEDIATO al click
    span.textContent = '✓  AÑADIDO';
    setTimeout(function(){
      span.textContent = btn.dataset.laeOriginalText || 'AÑADIR AL CARRITO';
    }, 2000);
  }, true);
})();


/* ============================================================
   LABEL TRANSLATIONS — Price/etc → español + pulse en cambio precio
   ============================================================ */
(function () {
  var LABELS = {
    'Price': 'Precio',
    'Regular price': 'Precio',
    'Sale price': 'Precio rebajado',
    'Unit price': 'Precio unitario',
    'Size': 'Tamaño',
    'Color': 'Color',
    'Quantity': 'Cantidad'
  };
  function translate() {
    // Hidden accessibility labels + visible labels
    document.querySelectorAll('.visually-hidden, .price__label, [class*="price"] span, legend, label').forEach(function(el){
      if (el.dataset.laeLabelDone) return;
      var t = (el.textContent || '').trim();
      if (LABELS[t]) {
        el.textContent = LABELS[t];
        el.dataset.laeLabelDone = '1';
      }
    });
  }
  if (document.readyState !== 'loading') translate();
  else document.addEventListener('DOMContentLoaded', translate);
  new MutationObserver(translate).observe(document.body, { childList: true, subtree: true });

  // Pulse en el precio cuando cambia la variante
  var lastPriceText = '';
  function pulsePriceOnChange() {
    var price = document.querySelector('.price [class*="price"]:not(.visually-hidden), .price');
    if (!price) return;
    var currentText = price.textContent.trim().replace(/\s+/g, ' ');
    if (lastPriceText && currentText !== lastPriceText) {
      price.style.transition = 'color .3s ease, transform .3s ease';
      price.style.color = '#5c7a4e';
      price.style.transform = 'scale(1.08)';
      setTimeout(function(){
        price.style.color = '';
        price.style.transform = '';
      }, 500);
    }
    lastPriceText = currentText;
  }
  // Listen to variant change events
  document.addEventListener('change', function(e){
    if (e.target.matches('input[type="radio"]') || e.target.closest('variant-picker, [class*="variant-picker"]')) {
      setTimeout(pulsePriceOnChange, 100);
    }
  }, true);
})();


/* ============================================================
   PRICE PULSE ON VARIANT — resalta el precio al cambiar variante
   ============================================================ */
(function () {
  function findPriceElements() {
    // Target the visible price containers on product page
    return document.querySelectorAll('.product-price, [class*="product-details"] .price, .price-container, product-price, [data-price]');
  }
  var lastPrices = new WeakMap();
  function pulse() {
    findPriceElements().forEach(function(el){
      var current = (el.textContent || '').trim().replace(/\s+/g, ' ');
      var prev = lastPrices.get(el);
      if (prev !== undefined && prev !== current) {
        el.style.transition = 'transform .35s cubic-bezier(.34,1.56,.64,1), background .4s ease, color .4s ease';
        el.style.transform = 'scale(1.12)';
        el.style.color = '#5c7a4e';
        el.style.background = 'rgba(92, 122, 78, 0.12)';
        el.style.borderRadius = '6px';
        el.style.padding = '2px 8px';
        el.style.display = 'inline-block';
        setTimeout(function(){
          el.style.transform = '';
          el.style.color = '';
          el.style.background = '';
          el.style.padding = '';
          el.style.display = '';
        }, 700);
      }
      lastPrices.set(el, current);
    });
  }
  // Initial
  if (document.readyState !== 'loading') setTimeout(pulse, 300);
  else document.addEventListener('DOMContentLoaded', function(){ setTimeout(pulse, 300); });
  // Listen to variant change
  document.addEventListener('change', function(e){
    if (e.target.matches('input[type="radio"]') || e.target.closest('variant-picker, [class*="variant-picker"], variant-selector')) {
      setTimeout(pulse, 150);
      setTimeout(pulse, 400);
    }
  }, true);
  // Listen to Horizon variant events
  ['variant:change', 'variant:update', 'product:variant-change'].forEach(function(ev){
    document.addEventListener(ev, function(){ setTimeout(pulse, 100); });
  });
})();


/* ============================================================
   LA ENCANTADA — Contact page anchors (mapea IDs de sección para el menú)
   ============================================================ */
(function(){
  if (!/\/pages\/contact/i.test(location.pathname)) return;
  const map = { tu_tienda: 'tu-tienda', contact_map: 'puntos-venta', contact_hero: 'contacto' };
  function apply(){
    Object.keys(map).forEach(k => {
      const el = document.querySelector('[id*="__' + k + '"]');
      if (el && !document.getElementById(map[k])) {
        // add a targetable anchor that respects sticky header offset
        const anchor = document.createElement('span');
        anchor.id = map[k];
        anchor.style.cssText = 'display:block;position:relative;top:-100px;visibility:hidden;';
        el.insertBefore(anchor, el.firstChild);
      }
    });
  }
  if (document.readyState !== 'loading') apply();
  else document.addEventListener('DOMContentLoaded', apply);
})();

/* ============================================================
   LA ENCANTADA — Drawer mobile: buscador arriba, secciones
   colapsadas con toggle, cuenta encima de idioma. Solo mobile (<750px).
   ============================================================ */
(function(){
  const MOBILE_MQ = window.matchMedia('(max-width: 749px)');

  function setupToggles(){
    if (!MOBILE_MQ.matches) return;
    const drawer = document.querySelector('#Details-menu-drawer-container');
    if (!drawer) return;
    const items = drawer.querySelectorAll('.menu-drawer__list-item--flat');
    items.forEach(li => {
      if (li.dataset.laeToggleReady === '1') return;
      const link = li.querySelector(':scope > a.menu-drawer__menu-item--mainlist');
      const sub  = li.querySelector(':scope > ul.menu-drawer__menu--childlist');
      if (!link || !sub) return;
      li.dataset.laeToggleReady = '1';
      li.classList.add('lae-mdrawer-toggle');
      li.setAttribute('data-lae-open', 'false');
      link.addEventListener('click', function(ev){
        if (!MOBILE_MQ.matches) return;
        ev.preventDefault();
        ev.stopPropagation();
        ev.stopImmediatePropagation();
        const isOpen = li.getAttribute('data-lae-open') === 'true';
        li.setAttribute('data-lae-open', String(!isOpen));
      }, {capture: true, passive: false});
    });
  }

  function injectSearchTop(){
    if (!MOBILE_MQ.matches) return;
    const nav = document.querySelector('#Details-menu-drawer-container .menu-drawer__navigation');
    if (!nav || nav.querySelector('.lae-mdrawer-search')) return;
    const form = document.createElement('form');
    form.action = '/search';
    form.method = 'get';
    form.className = 'lae-mdrawer-search';
    form.innerHTML = `
      <span class="lae-mdrawer-search__icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="9" cy="9" r="6.25" stroke="currentColor" stroke-width="1.5"/>
          <path d="M17 17l-3.5-3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </span>
      <input type="search" name="q" placeholder="Buscar productos" autocomplete="off" class="lae-mdrawer-search__input" />
      <input type="hidden" name="options[prefix]" value="last" />
    `;
    nav.insertBefore(form, nav.firstChild);
  }

  function injectAccountAboveLang(){
    if (!MOBILE_MQ.matches) return;
    const localWrap = document.querySelector('#Details-menu-drawer-container .menu-drawer__localization');
    if (!localWrap || localWrap.parentElement.querySelector('.lae-mdrawer-account')) return;
    const accountLink = document.createElement('a');
    accountLink.href = '/account';
    accountLink.className = 'lae-mdrawer-account';
    accountLink.innerHTML = `
      <span class="lae-mdrawer-account__icon" aria-hidden="true">
        <svg width="18" height="20" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path stroke="currentColor" stroke-linejoin="round" stroke-width="1.5"
                d="M10.375 3.813a3.063 3.063 0 1 1-6.125 0 3.063 3.063 0 0 1 6.125 0ZM7.313 9.5c-3.667 0-6.24 2.691-6.563 6.125h13.125C13.552 12.191 10.979 9.5 7.312 9.5Z"/>
        </svg>
      </span>
      <span>Mi cuenta</span>
    `;
    localWrap.parentElement.insertBefore(accountLink, localWrap);
  }

  // Sustituir thumbs por versión "menu_image_mobile" cuando existe
  function swapMobileImages(){
    if (!MOBILE_MQ.matches) return;
    const dataEl = document.querySelector('script[data-lae-mm-images]');
    if (!dataEl) return;
    let map;
    try { map = JSON.parse(dataEl.textContent || '{}'); } catch(e){ return; }
    if (!map || typeof map !== 'object') return;
    document.querySelectorAll('#Details-menu-drawer-container .menu-drawer__menu-item--child').forEach(a => {
      const href = a.getAttribute('href') || '';
      const m = href.match(/\/products\/([^/?#]+)/);
      if (!m) return;
      const handle = m[1];
      const url = map[handle];
      if (!url) return;
      const img = a.querySelector('img.menu-drawer__link-image, img');
      if (!img || img.dataset.laeMmSwapped === '1') return;
      img.dataset.laeMmSwapped = '1';
      img.src = url;
      // También limpiar srcset para que no use el original responsive
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
    });
  }

  function setupAll(){
    setupToggles();
    injectSearchTop();
    injectAccountAboveLang();
    swapMobileImages();
  }

  if (document.readyState !== 'loading') setupAll();
  else document.addEventListener('DOMContentLoaded', setupAll);

  // Re-run cuando se abra el drawer (por si el DOM se re-hidrata)
  document.addEventListener('click', function(e){
    if (e.target.closest('.header__icon--menu, #Details-menu-drawer-container > summary')){
      setTimeout(setupAll, 80);
      setTimeout(setupAll, 400);
    }
  }, true);
  // Al volver a desktop, resetear estados abiertos
  MOBILE_MQ.addEventListener('change', function(e){
    if (!e.matches){
      document.querySelectorAll('.menu-drawer__list-item--flat[data-lae-open]').forEach(li=>{
        li.removeAttribute('data-lae-open');
      });
    } else {
      setupAll();
    }
  });
})();

// La Encantada — Toggle bundle collapsible without triggering re-render
document.addEventListener('click', function(e){
  var btn = e.target && e.target.closest && e.target.closest('[data-lae-bundle-toggle]');
  if(!btn) return;
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();
  var wrap = btn.closest('.lae-drawer-bundle');
  if(!wrap) return;
  var body = wrap.querySelector('.lae-drawer-bundle__body');
  if(!body) return;
  var isOpen = wrap.classList.toggle('is-open');
  body.hidden = !isOpen;
  btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  window.__laeBundleOpen = isOpen;
}, true);


/* ============================================================
   Instagram — dots del carrusel movil
   ============================================================
   El carrusel en si es CSS (scroll-snap); esto solo pinta los puntos y los
   mantiene en sintonia con el dedo. Solo en movil: en escritorio la seccion
   sigue siendo una fila de fotos y los dots no pintan nada.                  */
(function () {
  var MOVIL = '(max-width: 749px)';

  function montar() {
    var seccion = document.querySelector('[id$="__instagram"]');
    if (!seccion) return;
    var rail = seccion.querySelector('.group-block-content.layout-panel-flex--row');
    if (!rail) return;

    var dots = seccion.querySelector('.lae-dots');
    var esMovil = window.matchMedia(MOVIL).matches;

    if (!esMovil) { if (dots) dots.remove(); return; }

    var laminas = [].slice.call(rail.querySelectorAll('.image-block'));
    if (laminas.length < 2) return;

    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'lae-dots';
      dots.setAttribute('role', 'group');
      dots.setAttribute('aria-label', 'Navegación de la galería');
      laminas.forEach(function (lam, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lae-dots__dot';
        b.setAttribute('aria-label', 'Ir a la imagen ' + (i + 1) + ' de ' + laminas.length);
        b.addEventListener('click', function () {
          var suave = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          lam.scrollIntoView({ inline: 'center', block: 'nearest', behavior: suave ? 'smooth' : 'auto' });
        });
        dots.appendChild(b);
      });
      // Fuera del .group-block, no dentro: ese bloque no crece para alojarlos
      // y los dots acababan solapando el boton "Síguenos". Como hermano del
      // grupo entran en el flex de la seccion y respetan su gap.
      var grupo = rail.closest('.group-block') || rail;
      grupo.parentNode.insertBefore(dots, grupo.nextSibling);
    }

    var botones = [].slice.call(dots.children);
    function marcar() {
      // La lamina activa es la que tiene el centro mas cerca del centro del rail
      var r = rail.getBoundingClientRect();
      var centro = r.left + r.width / 2;
      var mejor = 0, dist = Infinity;
      laminas.forEach(function (lam, i) {
        var lr = lam.getBoundingClientRect();
        var d = Math.abs(lr.left + lr.width / 2 - centro);
        if (d < dist) { dist = d; mejor = i; }
      });
      botones.forEach(function (b, i) {
        if (i === mejor) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
      });
    }

    var esperando = false;
    rail.addEventListener('scroll', function () {
      if (esperando) return;
      esperando = true;
      requestAnimationFrame(function () { marcar(); esperando = false; });
    }, { passive: true });
    window.addEventListener('resize', marcar);

    // marcar() a secas corre antes de que el CSS del carrusel haya colocado el
    // rail, asi que daba como activa la segunda imagen con el scroll a cero.
    // Y sin que nadie desplace nada, no se vuelve a llamar nunca.
    marcar();
    requestAnimationFrame(marcar);
    setTimeout(marcar, 400);
    window.addEventListener('load', marcar);
    rail.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', marcar, { once: true });
    });
  }

  if (document.readyState !== 'loading') montar();
  else document.addEventListener('DOMContentLoaded', montar);
  // Al cruzar el breakpoint hay que montar o retirar los dots
  var mq = window.matchMedia(MOVIL);
  if (mq.addEventListener) mq.addEventListener('change', montar);
})();
